/* Opt-in editorial gallery links only. Never changes images, picker, forms or navigation state. */
(function (win) {
  'use strict';
  if (!win || !win.customElements || win.customElements.get('shamos-gallery-links')) return;
  var LINK = 'a[data-gallery-product-id]';
  var CARD = '[data-gallery-card-product-id]';
  var ACTIVATION = ['focus', 'click', 'auxclick', 'contextmenu', 'keydown'];

  class GalleryLinks extends win.HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.onRefresh = () => this.update();
      this.onChange = (event) => {
        var config = this.readConfig(), owner = config && this.owner(config.source);
        // Ignore quickviews and unrelated controllers. Re-check an old owner if ownership was lost.
        if ((owner && event.target === owner.scope) || (this.scope && event.target === this.scope)) this.update();
      };
      this.onPending = (event) => {
        var config = this.readConfig(), owner = config && this.owner(config.source);
        if (owner && config.source.category !== 'phone' && event.target === owner.picker) this.update();
      };
      this.onNative = (event) => {
        var config = this.readConfig(), owner = config && this.owner(config.source), detail = event.detail;
        if (!owner || !owner.picker || config.source.category === 'phone' || !detail || String(detail.productId) !== config.source.id || String(detail.sectionId) !== owner.sectionId) return;
        if (!Number.isInteger(detail.renderVersion) || detail.renderVersion < 1 || detail.renderVersion !== owner.picker.renderVersion || detail.renderVersion !== owner.picker.siblingSettledRenderVersion) return;
        // Event metadata is a notification only. The owning settled picker remains authoritative.
        this.update();
      };
      this.onActivate = (event) => {
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
        var link = event.target && event.target.closest && event.target.closest(LINK);
        if (!link || link.closest('shamos-gallery-links') !== this) return;
        this.update();
        if (!link.getAttribute('href')) event.preventDefault();
      };
      this.ownerDocument.addEventListener('shamos:model-choice-change', this.onChange);
      win.addEventListener('pageshow', this.onRefresh);
      ACTIVATION.forEach((type) => this.addEventListener(type, this.onActivate, true));
      this.update();
      // A custom element may connect before its JSON or both native links have been parsed.
      if (win.MutationObserver) {
        var attempts = 0;
        this.dataObserver = new win.MutationObserver(() => {
          this.update();
          if (++attempts >= 64) this.stopWaiting();
        });
        this.dataObserver.observe(this, { childList: true, subtree: true, characterData: true });
        this.dataTimer = win.setTimeout(() => this.stopWaiting(), 5000);
      }
    }
    stopWaiting() {
      if (this.dataObserver) this.dataObserver.disconnect();
      if (this.dataTimer) win.clearTimeout(this.dataTimer);
      this.dataObserver = null;
      this.dataTimer = null;
    }
    disconnectedCallback() {
      this.update(true);
      this.connected = false;
      this.stopWaiting();
      this.ownerDocument.removeEventListener('shamos:model-choice-change', this.onChange);
      this.watchNative(null);
      win.removeEventListener('pageshow', this.onRefresh);
      ACTIVATION.forEach((type) => this.removeEventListener(type, this.onActivate, true));
      this.scope = null;
      this.lastConfig = null;
    }
    readConfig() {
      this.helper = win.ShamosSiblingMatcher || this.helper;
      if (!this.helper) return null;
      try {
        var script = this.querySelector('script[data-gallery-link-data]');
        if (!script || script.closest('shamos-gallery-links') !== this) return null;
        var raw = JSON.parse(script.textContent), source = this.helper.normalize(raw.source);
        if (!source || ['phone', 'airpods', 'kindle', 'stand'].indexOf(source.category) < 0 || !Array.isArray(raw.targets)) return null;
        var seen = new Set();
        if (raw.targets.some(function (target) {
          if (!target || !/^[1-9][0-9]*$/.test(String(target.id)) || seen.has(String(target.id))) return true;
          seen.add(String(target.id)); return false;
        })) return null;
        var labels = raw.labels || {};
        if (source.category !== 'phone' && ['unavailable', 'updating'].some(function (key) { return typeof labels[key] !== 'string' || !labels[key].trim(); })) return null;
        return { source: source, targets: raw.targets, labels: {
          unavailable: labels.unavailable || '',
          updating: labels.updating || ''
        } };
      } catch (_) { return null; }
    }
    owner(source) {
      var pickers = Array.from(this.ownerDocument.querySelectorAll('main-product variant-picker[data-main-product="true"]'))
        .filter((picker) => String(picker.dataset.productId) === source.id);
      if (pickers.length !== 1) return source.category !== 'phone' && pickers.length ? { picker: null } : null;
      var picker = pickers[0];
      if (source.category !== 'phone') {
        var sectionId = picker.dataset.sectionId;
        return typeof sectionId === 'string' && sectionId ? { picker: picker, sectionId: sectionId, scope: null } : { picker: null };
      }
      var scope = picker.closest('[data-model-choice-state]');
      if (!scope || String(scope.dataset.modelChoiceProduct || scope.dataset.modelChoiceProductId) !== source.id) return null;
      return { picker: picker, scope: scope };
    }
    watchNative(owner) {
      var sectionId = owner && owner.sectionId;
      if (sectionId === this.nativeSectionId) return;
      if (this.nativeSectionId) {
        this.ownerDocument.removeEventListener('maximize:variant-picker:updated:' + this.nativeSectionId, this.onNative);
        this.ownerDocument.removeEventListener('shamos:variant-render-pending:' + this.nativeSectionId, this.onPending);
      }
      this.nativeSectionId = sectionId || null;
      if (this.nativeSectionId) {
        this.ownerDocument.addEventListener('maximize:variant-picker:updated:' + this.nativeSectionId, this.onNative);
        this.ownerDocument.addEventListener('shamos:variant-render-pending:' + this.nativeSectionId, this.onPending);
      }
    }
    nativeState(source, owner) {
      var picker = owner && owner.picker;
      if ((!picker && source.variantCount > 1) || (owner && !picker)) return null;
      // A started request remains unsafe on error, cancellation or supersession until a latest commit.
      if (picker && picker.renderVersion != null && picker.renderVersion !== 0 && (!Number.isInteger(picker.renderVersion) || picker.renderVersion < 1 || picker.renderVersion !== picker.siblingSettledRenderVersion)) return null;
      var selected = picker && 'currentVariant' in picker ? this.helper.selected(source, picker.currentVariant) :
        (picker && picker.renderVersion ? null : this.helper.initial(source));
      return { productId: source.id, ready: Boolean(selected), state: selected ? 'ready' : 'unset', variantId: selected && selected.id };
    }
    update(forceChoice) {
      if (!this.connected) return;
      var config = this.readConfig(), helper = this.helper;
      if (!helper) return; // Server phone links require choice; accessory anchors have no href.
      var owner = config && this.owner(config.source), state = null;
      this.scope = owner && owner.scope;
      this.watchNative(owner);
      if (!forceChoice && config) {
        if (config.source.category !== 'phone') state = this.nativeState(config.source, owner);
        else if (owner && config.source.modelPosition && win.ShamosModelChoice && typeof win.ShamosModelChoice.getState === 'function') {
          try { state = win.ShamosModelChoice.getState(owner.picker); } catch (_) { /* Fail closed. */ }
        }
      }
      if (!state || state.state !== 'ready' || state.ready !== true || String(state.productId) !== config.source.id) state = null;
      // Invalid editor data can revoke exact matches, but never keep a previous variant URL alive.
      if (config) this.lastConfig = config;
      var data = config || this.lastConfig, links = new Map();
      var pending = owner && owner.picker && owner.picker.renderVersion && owner.picker.renderVersion !== owner.picker.siblingSettledRenderVersion;
      var unavailable = data ? data.labels[pending ? 'updating' : 'unavailable'] : '';
      var current;
      try {
        current = new URL(win.location.href);
        current.searchParams.delete('view'); // Keep each destination's real assigned product template.
      } catch (_) { current = null; }
      if (data && current) data.targets.forEach((target) => {
        var variant = null;
        if (config && state) {
          if (String(target.id) === config.source.id) {
            variant = helper.sourceVariant(config.source, state);
            if (variant && !variant.available) variant = null;
          } else {
            var decision = helper.resolve(config.source, target, state);
            if (decision.kind === 'exact') variant = decision.variant;
          }
        }
        var phone = data.source.category === 'phone';
        var href = (phone || variant) && helper.url(target.url, variant && variant.id, current.href, phone);
        var title = typeof target.title === 'string' && target.title ? target.title : 'this design';
        links.set(String(target.id), {
          href: href,
          label: 'Shop ' + title + ': ' + (variant ? variant.options.join(' · ') : phone ? 'Choose phone model' : unavailable),
          status: phone || (variant && href) ? '' : unavailable
        });
      });
      this.querySelectorAll(LINK).forEach((link) => {
        if (link.closest('shamos-gallery-links') !== this) return;
        var result = links.get(link.getAttribute('data-gallery-product-id'));
        if (result && result.href) link.setAttribute('href', result.href);
        else link.removeAttribute('href');
        if (data && data.source.category !== 'phone' && (!result || !result.href)) link.setAttribute('aria-disabled', 'true');
        else if (data) link.removeAttribute('aria-disabled');
        if (link.hasAttribute('data-gallery-cta') && data && data.source.category !== 'phone') link.hidden = !result || !result.href;
        if (result || data) link.setAttribute('aria-label', result ? result.label : 'Shop this design: ' + (data.source.category !== 'phone' ? unavailable : 'Choose phone model'));
      });
      // Keep the native carousel's slide count and editorial photography unchanged.
      this.querySelectorAll(CARD).forEach((card) => {
        if (card.closest('shamos-gallery-links') !== this) return;
        var result = links.get(card.getAttribute('data-gallery-card-product-id'));
        var status = card.querySelector('[data-gallery-link-status]');
        if (status) {
          var text = result ? result.status : unavailable;
          if (data && status.textContent !== text) status.textContent = text;
          status.hidden = Boolean(result && result.href && !result.status);
        }
      });
    }
  }
  win.customElements.define('shamos-gallery-links', GalleryLinks);
})(typeof window === 'undefined' ? null : window);
